import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { Card } from 'reactstrap';
import {
   SortingState,
   IntegratedSorting,
   PagingState,
   IntegratedPaging,
   SearchState,
   IntegratedFiltering
} from '@devexpress/dx-react-grid';
import {
  Grid,
  Table,
  TableHeaderRow,
  //PagingPanel,
  SearchPanel,
  Toolbar,
  TableColumnReordering,
  DragDropProvider,
  TableColumnVisibility,
  ColumnChooser
} from '@devexpress/dx-react-grid-bootstrap4';
import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
var styles=require('./Report.less');
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';
import * as commonActions from './../../actions/commonActions';
import * as reportActions from './../../actions/reportActions';
// import DatePicker from 'react-datepicker';
import moment from 'moment';
// import '../../theme/styles/daterangepicker.css';
// import 'react-datepicker/dist/react-datepicker.css';
import '../../theme/styles/styles.css';
// import DateRangePicker from 'react-bootstrap-daterangepicker';
import '../../theme/styles/bootstraptable.css';
import * as instrumentListActions from './../../actions/instrumentListActions';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import '../../theme/styles/mediaqueries.css';
import config from './../../config.js';
import { DcoDropdown } from './../../components/UI/Dropdown/Dropdown';
import Modal from 'react-modal';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import i18next from 'i18next';
import { applyStyle, getCountofTableRows,applyToHover, setDirection } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import numeral  from 'numeral';
import DateSelector from './../DateSelector/DateSelector';
import { getSelectedDate } from './../../utils/utils'; //import
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
let compareRate = (a, b) => {
  let result;
    if (numeral(a)._value < numeral(b)._value) {
      result = -1;
    }else{
      result = 1;
    }
    return result;
};
let defAccFlag = true;
let fileName = "Rpt_Onl_Ord_Out";

const elementsData = [
  {"classNames":"onlinefilterBar", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"onlineOrdTable", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"reportsDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-toggle", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"caret", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dropdown-menu", "elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"dropDownList", "elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"reportTblBg", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"glyphicon", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"material-icons", "elementType":"normal", "applyTo":"all", "tagNames":"i"},
  {"classNames":"reportsTblGrid", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"form-control", "elementType":"tag", "applyTo":"all", "tagNames":"input"},
  {"classNames":"oi-eye", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"text-muted", "elementType":"normal", "applyTo":"all", "tagNames":"big", "parent":"dx-g-bs4-fixed-block"},
  {"classNames":"", "elementType":"tag", "applyTo":"all", "tagNames":"th", "parent":"reportsTbl"},
  {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table", "elementType":"normal", "applyTo":"all", "tagNames":"table"},
  {"classNames":"dx-g-bs4-header-cell", "elementType":"tag", "applyTo":"all", "tagNames":"th"},
  {"classNames":"dx-g-bs4-table-cell", "elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"noDataCell", "elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"pagingPanelDiv", "elementType":"tag", "applyTo":"all", "tagNames":"span"},
  {"classNames":"closeBtn" ,"elementType":"normal", "applyTo":"single", "tagNames":"div"},
];

const directionData=[
  {"classNames":"commonGoBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"onlDrpdownDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"btnText", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu", "elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"reportsTblGrid", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"allExportFilter", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
];

@connect(state => ({
   OnlinetbleData: state.dashboardRoot.reportReducer.OnlinetbleData,
   socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
   defAcc: state.dashboardRoot.dashboardReducer.defAcc,
   loadRptFlag:state.dashboardRoot.reportReducer.loadRptFlag,
   ACD: state.auth.ACD,
   DFA: state.auth.DFA,
   DCO:state.dashboardRoot.instrumentListReducer.DCO,
   trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
   selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
   selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
   openCalender: state.dashboardRoot.commonReducer.openCalender,
   selectedLang:state.dashboardRoot.commonReducer.selectedLang,
   language:state.dashboardRoot.commonReducer.language
  }), {
  ...reportActions,
  ...instrumentListActions,
  ...commonActions
})

export default class ReportComponent extends Component {
  static propTypes = {
    OnlinetbleData: PropTypes.object,
    loadOnlineReport: PropTypes.func,
    socketDataStatic: PropTypes.array,
    generateOnlReportPdf:PropTypes.func,
    ACD: PropTypes.object,
    DFA: PropTypes.object,
    trdPanelData: PropTypes.object,
    getInvoice: PropTypes.func,
    openCalender:PropTypes.boolean,
    onClickCalender:PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {
      // fromDate: '',
      // toDate: '',
      onlineAcc_opt: this.props.DFA.D,
      onlineAcc_optKey:this.props.DFA.C,
      onlineCmdty_opt: '',
      onlineCmdty_optKey:'',
      onlineOrder_opt: 'outstanding',
      onlineOrder_optKey:'O',
      onlinecreatby_optKey:2,
      onlineEventTime: '',
      onlineEventTimeKey:'',
      onlinecreatby_opt:'createdByAll',
      OnlinetbleData:this.props.OnlinetbleData,
      CmdtyPairdata:[],
      showRptDialog: false,
      loadtableflag :true,
      isRefreshDisabled : true,
      isClearOnlineReg:false,
      currentDate: new Date().toLocaleDateString('en-US'),
      startDate: new Date().toLocaleDateString('en-US'),
      endDate: new Date().toLocaleDateString('en-US'),
      outLmtOrdColumnExtensions: [],
      ranges: {
        [i18next.t('today')]: [
          moment(), moment()
        ],
        [i18next.t('yesterday')]: [
          moment().subtract(1, 'days'),
          moment().subtract(1, 'days')
        ],
        [i18next.t('last7Days')]: [
          moment().subtract(6, 'days'),
          moment()
        ],
        [i18next.t('last30Days')]: [
          moment().subtract(29, 'days'),
          moment()
        ],
        [i18next.t('thisMonth')]: [
          moment().startOf('month'), moment().endOf('month')
        ],
        [i18next.t('lastMonth')]: [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
      },
      CmdtyPair:'',
      OutstandingcolsExtensions:[
        {columnName:'placedBy', width:115},
        {columnName:'docno', width:115},
        {columnName:'deal_type', width:165},
        {columnName:'stk_desc', width:85},
        {columnName:'pcs_qty', width:80, align:'right'},
        {columnName:'price1', width:115, align:'right'},
        {columnName:'VT', width:250},
        {columnName:'ord_status', width:120},
        {columnName:'FNC', width:195},
        {columnName:'remarks', width:175}
      ],
      FilledcolsExtensions:[
        {columnName:'placedBy', width:115},
        {columnName:'docno', width:165},
        {columnName:'deal_type', width:95},
        {columnName:'stk_desc', width:85},
        {columnName:'ET', width:205},
        {columnName:'pcs_qty', width:115, align:'right'},
        {columnName:'price1', width:115, align:'right'},
        {columnName:'FNC', width:295},
        {columnName:'remarks', width:155}
      ],
      pageSizes: [10, 15, 20, 0],
      searchValue:'',
      HiddenOutstandingTableCol:[],
      HiddenFillTableCol:[],
      HiddenCancelledTableCol:[],
      HiddenExpiredTableCol:[],
      HiddenAllTableCol:[],
      accountList:Array.from(this.props.ACD.values()),
      // qty_type: '',
      // qty_types: '',
      integratedSortingColumnExtensions: [
        {columnName:'price1', compare:compareRate, align:'right'},
        {columnName:'pcs_qty', compare:compareRate, align:'right'}
      ],
      id:'today',
      keyValue:'onlineOrderReport',
      validationFlag:false,
      validationMsg:"",
      reportsRowsCount:0,
      Outstandingcols:["placedBy","docno","deal_type","stk_desc","pcs_qty","ord_stk_code","price1","VT","ord_status","remarks"],
      Filledcols:["placedBy","docno","deal_type","stk_desc","ET","pcs_qty","ord_stk_code","price1","FNC","remarks"],
      Cancelledcols:["placedBy","docno","deal_type","stk_desc","ET","pcs_qty","ord_stk_code", "cancelledBy" ,"price1","VT","remarks"],
      Expiredcols:["placedBy","docno","deal_type","stk_desc","ET","pcs_qty","ord_stk_code","price1","VT","remarks"],
      Allcols:["placedBy","docno","deal_type","stk_desc","pcs_qty","ord_stk_code","price1","VT","ord_status","FNC","remarks"],
    }
    this.onChangeHiddenOutstandingTableCol = this.onChangeHiddenOutstandingTableCol.bind(this);
    this.onChangeHiddenFillTableCol = this.onChangeHiddenFillTableCol.bind(this);
    this.onChangeHiddenCancelledTableCol = this.onChangeHiddenCancelledTableCol.bind(this);
    this.onChangeHiddenExpiredTableCol = this.onChangeHiddenExpiredTableCol.bind(this);
    this.onChangeHiddenAllTableCol = this.onChangeHiddenAllTableCol.bind(this);
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    window.getDecimal = this.getDecimal.bind(this);
    //const accountList=Array.from(this.props.ACD.values());
    const dco = this.props.DCO;
    const accountlen=this.state.accountList.length;
    for(let i=0;i<accountlen;i++){
      const account=this.props.DFA.D;
      this.setState({onlineAcc_opt: account});
    }
    this.setState({onlineAcc_optKey:this.props.DFA.C});
    this.setState({onlinecreatby_opt:"createdByAll"});
    this.setState({onlinecreatby_optKey:'2'});
    let cmdtyId;
    var dcoOnlineord = [];
    // let obj1 = {
    //   cmdtyId: '',
    //   cmdty: 'Cmdty Pair'
    // };
    // dcoOnlineord.push(obj1);
    let obj1 = {
      cmdtId: 'All',
      cmdtDesc: i18next.t('allPairs')
    };
    var obj=this.props.DCO;
    if(obj.findIndex(x => x.cmdtId=='All') === -1 && obj.length > 1){
      obj.unshift(obj1);
    }
    // dcoOnlineord.push(obj1);
    // for (let index = 0; index <this.props.socketDataStatic.length; index++) {
    //   const cmdty = this.props.socketDataStatic[index].I;
    //   const cmdtyDes = this.props.socketDataStatic[index].ID;
    //   if (dco.indexOf(this.props.socketDataStatic[index].I) !== -1) {
    //     let obj = {
    //       cmdtyId:cmdty,
    //       cmdty: cmdtyDes
    //     }
    //     dcoOnlineord.push(obj);
    //   }
    // }
    this.setState({CmdtyPairdata: obj});
    this.setState({onlineCmdty_opt: obj[0].cmdtDesc});
    this.setState({onlineCmdty_optKey:obj[0].cmdtId ==="All" ? "":obj[0].cmdtId});
    this.setState({onlineOrder_opt:'outstanding'});
    this.setState({order_opt:'O'});
    this.setState({onlineEventTime:''});
    this.setState({onlineOrder_optKey:'O'});
    this.setState({qtyType:''});
  }

  componentWillMount() {
    let outColsExtension =[];
    outColsExtension = [
      {columnName:'price1',align: 'right', width:500}
    ]
    this.setState({outLmtOrdColumnExtensions: outColsExtension});
    const locale = locale;
    this.setState({
      locale: {
        'format': 'DD-MM-YYYY',
        applyLabel: i18next.t('apply'),
        cancelLabel: i18next.t('cancel'),
        customRangeLabel:  i18next.t('customRange'),
        daysOfWeek: [
          i18next.t("su"),i18next.t("mo"),i18next.t("tu"),i18next.t("we"),i18next.t("th"),i18next.t("fr"),i18next.t("sa")
        ],
        monthNames:[
          i18next.t("jan"),i18next.t("feb"),i18next.t("mar"),i18next.t("apr"),i18next.t("may"),i18next.t("jun"),i18next.t("jul"),  i18next.t("aug"),i18next.t("sep"),i18next.t("oct"),i18next.t("nov"),i18next.t("dec")
        ]
      },
    });
  }

  handleEvent = (event,picker) => {
    try{
      this.setState({startDate: picker.startDate.format('DD-MM-YYYY'), endDate: picker.endDate.format('DD-MM-YYYY')});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleEvent', component:"OnlineOrderReport"});
    }
  }

  closeRptModal = (event) => {
    try{
      this.setState({showRptDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"OnlineOrderReport"});
    }
  }

  getDecimal=(CmdtyPair)=>{
    try{
      var dec;
      for (let index = 0; index <this.props.socketDataStatic.length; index++) {
        if (this.props.socketDataStatic[index].ID === CmdtyPair) {
          dec = this.props.socketDataStatic[index].dec
          break;
        }
      }
      return dec;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getDecimal', component:"OnlineOrderReport"});
    }
  }

  formatPrice=(cell, row)=>{
    try{
      var rowstk_desc=row.stk_desc;
      var dec=getDecimal(rowstk_desc);
      return(Number(cell).toLocaleString(navigator.language,{ minimumFractionDigits: dec}));
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'formatPrice', component:"OnlineOrderReport"});
    }
  }

  formatQuantity=(cell, row)=>{
    try{
      return(Number(cell).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }))+ " "+row.ord_stk_code;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'formatQuantity', component:"OnlineOrderReport"});
    }
  }

  revertSortFunc=(a, b, order)=> {   // order is desc or asc
    try{
      if (order === 'desc') {
        return a.pcs_qty - b.pcs_qty;
      } else {
        return b.pcs_qty - a.pcs_qty;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'revertSortFunc', component:"OnlineOrderReport"});
    }
  }

  getOnlineReg=()=>{
    try {
      this.setState({
        loadtableflag: true,
        isRefreshDisabled: true,
        order_opt: this.state.onlineOrder_optKey
      });
      //setTimeout(() => this.setState({ loadtableflag: true }), 900);
      this.props.loadOnlineReport(moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.onlineCmdty_optKey, this.state.onlineOrder_optKey, this.state.onlineEventTimeKey, this.state.onlineAcc_optKey, this.state.onlinecreatby_optKey, '');
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'getOnlineReg', component: "OnlineOrderReport" });
    }
  }

  // changeQty_type = (qnt_type) => {
  //   this.setState({qty_type: qnt_type});
  // }

  componentDidUpdate(prevProps){
    // if(prevProps.OnlinetbleData !== this.props.OnlinetbleData){
    //   this.refs.orderonlineTbl.reset();
    // }
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
  }

  componentWillReceiveProps(nextProps){
    const thisComponent = ReactDOM.findDOMNode(this);
   // //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //     {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
    //     {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // };
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
      let obj1 = {
        cmdtId: 'All',
        cmdtDesc: i18next.t('allPairs')
      };
      var obj=this.props.DCO;
      if(obj.findIndex(x => x.cmdtId=='All') === -1){
        obj.unshift(obj1);
      }else{
        var index = obj.findIndex(x => x.cmdtId=='All');
        obj.splice(index,1);
        obj.unshift(obj1);
      }
      this.setState({CmdtyPairdata: obj});
    }
    if(this.props.isSearch !== nextProps.isSearch){
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled : false });
    }
    if(this.state.isClearOnlineReg !== this.props.isClearOnlineReg){
      this.setState({ isClearOnlineReg: true });
      this.setState({ loadtableflag: true });
      this.setState({isRefreshDisabled:true});
      this.setState({startDate: new Date().toLocaleDateString('en-US')});
      this.setState({endDate:new Date().toLocaleDateString('en-US')});
      this.setState({currentDate: new Date().toLocaleDateString('en-US')});
      this.setState({id:'today'});
    }
    if(nextProps.OnlinetbleData !== this.props.OnlinetbleData){
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled : false });
      this.setState({reportsRowsCount:nextProps.OnlinetbleData.length});
    }
  // if(nextProps.loadRptFlag !== this.state.loadtableflag){
  //     this.setState({ loadtableflag: false });
  //     this.setState({ isRefreshDisabled : false });
  //   }
    if(nextProps.defAcc !== this.props.defAcc){
      this.setState({onlineAcc_opt: nextProps.defAcc.AD});
      this.setState({onlineAcc_optKey:nextProps.defAcc.AC})
    }
  }

  setStartDate = startDate => {
    try{
      this.setState({ startDate:startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"OnlineOrderReport"});
    }
  }

  setEndDate = endDate => {
    try{
      this.setState({ endDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"OnlineOrderReport"});
    }
  }

  closeValidationModal=()=>{
    try{
      this.setState({validationFlag :false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"OnlineOrderReport"});
    }
  }

  // chnageAccPos(key) {
    // this.props.ChnageAccount(key,"trader");
    // if (defAccFlag === false) {
    //   setTimeout(() => {
    //     this.chnageAccPos(key);
    //   }, 30000);
    // }
  // }

  onlineAcc_opt = (text,key) => {
    try {
      this.setState({onlineAcc_opt: text});
      this.setState({onlineAcc_optKey:key});
      if (this.props.DFA.C !== key) {
        defAccFlag = false;
        this.setState({AccFlag: false});
        // this.chnageAccPos(key);
        //this.setState(defAccFlag:false);
      } else {
        defAccFlag = true;
        this.setState({AccFlag: true});
      }
      this.setState({ loadtableflag: true });
      this.props.loadOnlineReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.onlineCmdty_optKey,this.state.onlineOrder_optKey,this.state.onlineEventTimeKey,key,this.state.onlinecreatby_optKey,'');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onlineAcc_opt', component:"OnlineOrderReport"});
    }
  }

  onlineCmdty_opt = (filterValue,filtertext) => {
    try{
      this.setState({onlineCmdty_opt: filtertext});
      this.setState({onlineCmdty_optKey:filterValue});
      var onlineCmdty_optKey=filterValue;
      if(filterValue == 'All'){
        this.setState({onlineCmdty_optKey: ''});
        onlineCmdty_optKey='';
        // this.setState({qty_types: ''});
        // this.setState({qty_type: ''});
      }else{
      let index1;
      for (let index = 0; index < this.props.socketDataStatic.length; index++) {
        const cmdty = this.props.socketDataStatic[index].I;
        const cmdtyDes = this.props.socketDataStatic[index].ID;
        if (filterValue === cmdty) {
            index1=index;
        }
        }
      const T1=this.props.socketDataStatic[index1].T1;
      const unit = [];
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        if (stk_type === T1) {
          unit.push(this.props.trdPanelData[index].C);
        }
      }
      // this.setState({qty_type: unit[0]});
      // this.setState({qty_types: unit});
      }
      this.setState({ loadtableflag: true });
      this.props.loadOnlineReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),onlineCmdty_optKey,this.state.onlineOrder_optKey,this.state.onlineEventTimeKey,this.state.onlineAcc_optKey,this.state.onlinecreatby_optKey,'');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onlineCmdty_opt', component:"OnlineOrderReport"});
    }
  }

  onlineOrder_opt = (text,value) => {
    try {
      this.setState({ onlineOrder_opt: text });
      this.setState({ onlineOrder_optKey: value });
      this.setState({ order_opt: value });
      var onlineEventTimeKey = '';
      var onlineOrder_optKey = value;
      if (value === 'O') {
        this.setState({ onlineEventTime: 'outstanding' });
        this.setState({ onlineEventTimeKey: '' });
        onlineEventTimeKey = '';
      }
      if (value === 'F') {
        this.setState({ onlineEventTime: "filledTime" });
        this.setState({ onlineEventTimeKey: "F" });
        onlineEventTimeKey = "F";
      }
      if (value === 'C') {
        this.setState({ onlineEventTime: "cancelledTime" });
        this.setState({ onlineEventTimeKey: "C" });
        onlineEventTimeKey = "C";
      }
      if (value === 'E') {
        this.setState({ onlineEventTime: "expiredTime" });
        this.setState({ onlineEventTimeKey: "E" });
        onlineEventTimeKey = "E";
      }
      if (value === 'A') {
        this.setState({ onlineEventTime: "eventTime" });
        this.setState({ onlineEventTimeKey: "V" });
        onlineEventTimeKey = "V";
      }
      this.setState({ loadtableflag: true });
      // for outstanding order set start and end date as today
      this.props.loadOnlineReport(
        moment(value === 'O' ? new Date() : this.state.startDate).format('DD-MM-YYYY'),
        moment(value === 'O' ? new Date() : this.state.endDate).format('DD-MM-YYYY'),
        this.state.onlineCmdty_optKey, onlineOrder_optKey, onlineEventTimeKey, this.state.onlineAcc_optKey, this.state.onlinecreatby_optKey, ''
      );
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'onlineOrder_opt', component: "OnlineOrderReport" });
    }   
  }

  onlineEventTime = (text,key) => {
    try{
      this.setState({onlineEventTime: text});
      this.setState({onlineEventTimeKey: key});
      this.setState({ loadtableflag: true });
      this.props.loadOnlineReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.onlineCmdty_optKey,this.state.onlineOrder_optKey,key,this.state.onlineAcc_optKey,this.state.onlinecreatby_optKey,'');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onlineEventTime', component:"OnlineOrderReport"});
    }
  }

  onlinecreatby_opt = (text,key) => {
    try{
      this.setState({onlinecreatby_opt: text});
      this.setState({onlinecreatby_optKey:key});
      this.setState({ loadtableflag: true });
      this.props.loadOnlineReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.onlineCmdty_optKey,this.state.onlineOrder_optKey,this.state.onlineEventTimeKey,this.state.onlineAcc_optKey,key,'');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onlinecreatby_opt', component:"OnlineOrderReport"});
    }
  }

  generatePdf=(format)=>{
    try {
      if (this.props.OnlinetbleData.length === 0 || this.props.OnlinetbleData === '' || this.props.OnlinetbleData === null) {
        this.setState({ showRptDialog: true });
      } else {
        this.setState({ showRptDialog: false });
        this.props.generateOnlReportPdf(moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.onlineCmdty_optKey, this.state.onlineEventTimeKey, this.state.onlineAcc_optKey, this.state.onlinecreatby_optKey, this.state.onlineOrder_optKey, format, this.state.onlineAcc_opt, '');
      }
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'generatePdf', component: "OnlineOrderReport" });
    }
  }

  changeFlag = () => {
    try{
      this.setState({showRptDialog: true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"OnlineOrderReport"});
    }
  }

  onChangeSearchValue(value){
    try{
      this.setState({searchValue: value });
      var count=this.state.order_opt==='O'? getCountofTableRows(this.props.OnlinetbleData,this.state.Outstandingcols,value)
      : this.state.order_opt==='F'? getCountofTableRows(this.props.OnlinetbleData,this.state.Filledcols,value)
      :this.state.order_opt==='C'? getCountofTableRows(this.props.OnlinetbleData,this.state.Cancelledcols,value)
      :this.state.order_opt==='E'? getCountofTableRows(this.props.OnlinetbleData,this.state.Expiredcols,value)
      :getCountofTableRows(this.props.OnlinetbleData,this.state.Allcols,value);
      this.setState({reportsRowsCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"OnlineOrderReport"});
    }
  }

  onChangeSearchValue(value){
    try{
      this.setState({searchValue: value });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"OnlineOrderReport"});
    }
  }
  onChangeHiddenOutstandingTableCol(hiddenCol){
    try{
      this.setState({ HiddenOutstandingTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenOutstandingTableCol', component:"OnlineOrderReport"});
    }
  };

  onChangeHiddenFillTableCol(hiddenCol){
    try{
      this.setState({ HiddenFillTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenFillTableCol', component:"OnlineOrderReport"});
    }
  };

  onChangeHiddenCancelledTableCol(hiddenCol){
    try{
      this.setState({ HiddenCancelledTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenCancelledTableCol', component:"OnlineOrderReport"});
    }
  };

  onChangeHiddenExpiredTableCol(hiddenCol){
    try{
      this.setState({ HiddenExpiredTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenExpiredTableCol', component:"OnlineOrderReport"});
    }
  };

  onChangeHiddenAllTableCol(hiddenCol){
    try{
      this.setState({ HiddenAllTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenAllTableCol', component:"OnlineOrderReport"});
    }
  };

  generateInvoice=(row)=>{
    try{
      var docNo=row.toString().split('""');
      var getdocType = row.toString().split('/');
      var docType=getdocType[0];
      if(docType !== 'PFC'){
        this.props.getInvoice(docNo,docType);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generateInvoice', component:"OnlineOrderReport"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      // //const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},

      ];
      //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"OnlineOrderReport"});
    }
  }

  render() {
    const {onlineAcc_opt,onlineCmdty_opt,onlineOrder_opt,onlineEventTime,onlinecreatby_opt,cmdtyKey,CmdtyPairdata,order_opt, onlineOrder_optKey}=this.state;
    const start = this.state.startDate;
    const end = this.state.endDate;
    // console.log(`${this.state.currentDate} Start Date ${this.state.startDate} EndDate ${this.state.endDate}`)
    let label = start+ ' - ' +end;
    if (start === end) {
      label = start;
    }
    if (onlineOrder_optKey === 'O') {
      fileName = "Rpt_Onl_Ord_Out";
    }
    else if (onlineOrder_optKey === 'F') {
      fileName = "Rpt_Onl_Ord_Fill";
    }
    else if (onlineOrder_optKey === 'C') {
      fileName = "Rpt_Onl_Ord_Can";
    }
    else if (onlineOrder_optKey === 'E') {
      fileName = "Rpt_Onl_Ord_Exp";
    }
    else if (onlineOrder_optKey === 'A') {
      fileName = "Rpt_Onl_Ord_All";
    }

    const Outstandingcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx: 110}},
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:100}},
      {name:'stk_desc', title:i18next.t('cmdtyPair'), width:{wpx:85}},
      {name:'pcs_qty', title:i18next.t('quantity'), align:'right', width:{wpx:110}},
      {name:'ord_stk_code', title:i18next.t('qtyType'), width:{wpx:80}},
      {name:'price1', title:i18next.t('price'), align:'right', width:{wpx:110}},
      {name:'VT', title:i18next.t('validity'), width:{wpx:250}},
      {name:'ord_status', title:i18next.t('status'), width:{wpx:120}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:400}}
    ];

    const Filledcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx:110}},
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:100}},
      {name:'stk_desc', title:i18next.t('cmdtyPair'), width:{wpx:85}},
      {name:'ET', title:i18next.t('filledTime'), width: {wpx:200}},
      {name:'pcs_qty', title:i18next.t('filledQty'), align:'right', width:{wpx:110}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'price1', title:i18next.t('price'), align:'right', width:{wpx:110}},
      {name:'FNC', title:i18next.t('docNo'), width:{wpx:150}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:400}}
    ];

    const Cancelledcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx:110}},
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:100}},
      {name:'stk_desc', title:i18next.t('cmdtyPair'), width:{wpx:85}},
      {name:'ET', title:i18next.t('cancelledTime'), width:{wpx:200}},
      {name:'pcs_qty', title:i18next.t('cancelledQty'), align:'right', width:{wpx:110}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'user_code', title:i18next.t('cancelledBy'), width:{wpx:100}},
      {name:'price1', title:i18next.t('price'), align:'right', width:{wpx:110}},
      {name:'VT', title:i18next.t('validity'), width:{wpx:250}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:400}}
    ];

    const Expiredcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx:110}},
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:100}},
      {name:'stk_desc', title:i18next.t('cmdtyPair'), width:{wpx:85}},
      {name:'ET', title:i18next.t('expiredTime'), width:{wpx:200}},
      {name:'pcs_qty', title:i18next.t('expiredQty'), align:'right', width:{wpx:110}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'price1', title:i18next.t('price'), align:'right', width:{wpx:110}},
      {name:'VT', title:i18next.t('validity'), width:{wpx:250}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:400}}
    ];

    const Allcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx:110}},
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:100}},
      {name:'stk_desc', title:i18next.t('cmdtyPair'), width:{wpx:85}},
      {name:'pcs_qty', title:i18next.t('quantity'), align:'right', width:{wpx:110}},
      {name:'ord_stk_code', title:i18next.t('qtyType'), width:{wpx:80}},
      {name:'price1', title:i18next.t('price'), align:'right', width:{wpx:110}},
      {name:'VT', title:i18next.t('validity'), width:{wpx:250}},
      {name:'ord_status', title:i18next.t('status'), width:{wpx:120}},
      {name:'FNC', title:i18next.t('docNo'), width:{wpx:150}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:400}}
    ];
    var tableDataOut = [];
    var tableDataFill = [];
    var tableDataCan = [];
    var tableDataExp = [];
    var tableDataAll = [];
    var propData = this.props.OnlinetbleData;

    for(let i=0;i<propData.length;i++){
      tableDataCan[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].stk_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].ET, style: {alignment: {horizontal:"left"}}} , {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].user_code, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].price1, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].VT, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

      tableDataAll[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].stk_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].price1, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].VT, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].ord_status, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].FNC, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

      tableDataExp[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].stk_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].ET, style: {alignment: {horizontal:"left"}}} , {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].price1, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].VT, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

      tableDataOut[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].stk_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].price1, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].VT, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].ord_status, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

      tableDataFill[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].stk_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].ET, style: {alignment: {horizontal:"left"}}} , {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].price1, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].FNC, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

    }

    let multiDataSetOut = [{
      columns: Outstandingcols,
      data: tableDataOut
    }];

    let multiDataSetFill = [{
      columns: Filledcols,
      data: tableDataFill
    }];

    let multiDataSetExp = [{
      columns: Expiredcols,
      data: tableDataExp
    }];

    let multiDataSetCan = [{
      columns: Cancelledcols,
      data: tableDataCan
    }];

    let multiDataSetAll = [{
      columns: Allcols,
      data: tableDataAll
    }];

    const pagingPanelMessages = {
      showAll: i18next.t(('all')),
      rowsPerPage: i18next.t('rowsPerPage'),
      info:'',
    };

    const searchPlaceholderMsg = {
      searchPlaceholder: i18next.t(('search'))+'...',
    };

    const PagingContainer = props => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );

    const PagingContainerdark = props => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark" />
    );

    const rowStyle = theme => ({
      tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
          //backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)': {
          // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        '& thead th': {
          //color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary': {
          //color: this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });

    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table {...restProps} id="onlOrdRptTable" className={classes.tableStriped}/>
    );

    const FillOrdersCell = props => {
      const { column } = props;
      if (column.name === "FNC") {
        return <InvoiceHighlightedCell {...props} />;
      }
      if(column.name === "pcs_qty" || column.name === "price1"){
        return <Table.Cell {...props} className="textAlignLeft" />;
      }
      if(column.name === "ET"){
        return <Table.Cell {...props} className="eventTimeCell" />;
      }
      return <Table.Cell {...props} />;
    };

    const AllOrdersCell = props => {
      const { column } = props;
      if (column.name === "FNC") {
        return <InvoiceHighlightedCell {...props} />;
      }
      if(column.name === "pcs_qty" || column.name === "price1"){
        return <Table.Cell {...props} className="textAlignLeft" />;
      }
      return <Table.Cell {...props} />;
    };

    const OutOrdersCell = props => {
      const { column } = props;
      if(column.name === "pcs_qty" || column.name === "price1"){
        return <Table.Cell {...props} className="textAlignLeft" />;
      }
      return <Table.Cell {...props} />;
    };

    const Cell = props => {
      const { column } = props;
      if(column.name === "pcs_qty" || column.name === "price1"){
        return <Table.Cell {...props} className="textAlignLeft" />;
      }
      if(column.name === "ET"){
        return <Table.Cell {...props} className="eventTimeCell" />;
      }
      return <Table.Cell {...props} />;
    };

    const InvoiceHighlightedCell = ({ value, style }) => (
      <Table.Cell>
        <span>
          {value.indexOf('PFC') === -1 ?
            <a className='trdeBookCell' title={i18next.t("invoiceDownldMsg")} onClick={()=>this.generateInvoice(value)}>
              {value}
            </a>
          : value}
        </span>
      </Table.Cell>
    );
    var NoDataMsg = {
      noData: '',
    }
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = '';
    } else {
      NoDataMsg.noData = i18next.t("noDataAvlMsg");
    }

    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell"  />
    );

    const dropDownListColor =theme =>({
      dropDownListHoverMenu:{
        '& .dropdown-item':{
          // background:this.props.selectedCssColorTheme.dropDownList.background,
          // color:this.props.selectedCssColorTheme.dropDownList.color
        },
        '& :hover':{
          // background:this.props.selectedCssColorTheme.dropDownListHover.background,
          // color:this.props.selectedCssColorTheme.dropDownListHover.color
        },
        '& .popover':{
          //background:this.props.selectedCssColorTheme.dropDownListHover.background
        }
      }
    });

    const ContainerColor = ({ classes, ...restProps }) => (
      <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu} />
    );
    const MenuColor = props => (
      <ColumnChooser.Item {...props} />
    );

    return (
      <div id="onlOrdRptDiv" className={`${this.props.language}`}>
        <Modal className={styles.warningModal} id="onlOrdDatevalModal" isOpen={this.state.validationFlag} onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.header} header`} >{i18next.t("error")}
              <span className={`${styles.closeImg} closeIcon`} onClick={this.closeValidationModal}>
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`} >
              <h4>{i18next.t((this.state.validationMsg))}</h4>
            </div>
          </div>
        </Modal>

        <Modal id="onlOrdModal" className={styles.warningModal} isOpen={this.state.showRptDialog} onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.header} header`} >
              <span className={`${styles.msgTitle}`}>{i18next.t('onlOrderBook')}</span>
              <span id="onlOrdCloseIcon"  className={`${styles.closeImg} closeIcon`}onClick={this.closeRptModal}>
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`} >
              {i18next.t("noDataAvlMsg")}
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
              <Button id="onlOrdCloseBtn" className='button-l' bsStyle="primary"  onClick={this.closeRptModal}>{i18next.t("OK")}</Button>
            </div>
          </div>
        </Modal>

        <div id="Onlfilterbar" className={`${styles.onlinefilterBar} onlinefilterBar ${this.props.selectedCssColor}`}>
          <div className={`${styles.onlinefilterBarInner} fltrBarInner`}>
            <div className={styles.optionsWrapper}>
                <div id="onlineOrdAcclist" className={`${styles.wrapper1} onlDrpdownDiv`}>
                <DropdownButton id="bg-nested-dropdown" className={`${styles.onlineAccount} reportsDropdown btnText`} title={i18next.t(onlineAcc_opt)}>
                    {this.state.accountList.map((item) =>{
                    return (
                        <MenuItem id="onlOrdAccListMenu" onClick={() => this.onlineAcc_opt(item.D, item.C)}>{item.D}</MenuItem>
                    );
                    })}
                </DropdownButton>
                </div>

                <DcoDropdown
                parentDivClassname={`${styles.onlinefiltercmdty} onlineOrdCmdtylist onlDrpdownDiv`}
                parentDivId="onlineOrdCmdtylist"
                dropdownTitle={i18next.t(onlineCmdty_opt)}
                dropdownId="bg-nested-dropdown"
                dropdownData={this.state.CmdtyPairdata}
                dataItemClick={this.onlineCmdty_opt}
                dropdownClassname="btnText"
                />

                <div id="onlineOrdOption" className={`${styles.onlinefilterOptions} onlDrpdownDiv`}>
                <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText" title={i18next.t(onlineOrder_opt)}>
                    <MenuItem id="onlOrdAll" onClick={() => this.onlineOrder_opt("all", "A")}>{i18next.t("all")}</MenuItem>
                    <MenuItem id="onlOrdOtstng" onClick={() => this.onlineOrder_opt("outstanding", "O")}>{i18next.t("outstanding")}</MenuItem>
                    <MenuItem id="onlOrdFilled" onClick={() => this.onlineOrder_opt("filled", "F")}>{i18next.t("filled")}</MenuItem>
                    <MenuItem id="onlOrdCancelled" onClick={() => this.onlineOrder_opt("cancelled", "C")}>{i18next.t("cancelled")}</MenuItem>
                    <MenuItem id="onlOrdExpired" onClick={() => this.onlineOrder_opt("expired", "E")}>{i18next.t("expired")}</MenuItem>
                </DropdownButton>
                </div>

                {onlineOrder_optKey === 'O' ?
                <div id="onlineOrdItem" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                    <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText"  disabled></DropdownButton>
                </div>
                : null}

                {onlineOrder_optKey === 'F' ?
                <div id="onlineOrdItem" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                    <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText"  title={i18next.t(onlineEventTime)}>
                    <MenuItem id="onlOrdEvntFilledTime"  onClick={() => this.onlineEventTime("filledTime", "F")}>{i18next.t("filledTime")}</MenuItem>
                    <MenuItem id="onlOrdEvntCreatedTime"  onClick={()  => this.onlineEventTime("createdTime", "D")}>{i18next.t("createdTime")}</MenuItem>
                    </DropdownButton>
                </div>
                : null}

                {onlineOrder_optKey === 'C' ?
                <div id="onlineOrdItem" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                    <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText"  title={i18next.t(onlineEventTime)}>
                    <MenuItem id="onlOrdEvntCancelTime"  onClick={() => this.onlineEventTime("cancelledTime", "C")}>{i18next.t("cancelledTime")}</MenuItem>
                    <MenuItem id="onlOrdEvntCreatTime"  onClick={() => this.onlineEventTime("createdTime", "D")}>{i18next.t("createdTime")}</MenuItem>
                    </DropdownButton>
                </div>
                : null}

                {onlineOrder_optKey === 'E' ?
                <div id="onlineOrdItem" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                    <DropdownButton title={i18next.t(onlineEventTime)} id="bg-nested-dropdown" className="reportsDropdown btnText" >
                    <MenuItem id="onlOrdEvntExpiredTime"  onClick={() => this.onlineEventTime("expiredTime", "E")}>{i18next.t("expiredTime")}</MenuItem>
                    <MenuItem id="onlOrdEvntCreatTime"  onClick={() => this.onlineEventTime("createdTime", "D")}>{i18next.t("createdTime")}</MenuItem>
                    </DropdownButton>
                </div>
                : null}

                {onlineOrder_optKey === 'A' ?
                <div id="onlineOrdItem" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                    <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText"  title={i18next.t(onlineEventTime)}>
                    <MenuItem  onClick={() => this.onlineEventTime("eventTime", "V")}>{i18next.t("eventTime")}</MenuItem>
                    </DropdownButton>
                </div>
                : null}

                <div id="onlineOrdSelectDate" className={`${styles.selectDatebtn} onlDrpdownDiv`}>
                <DateSelector
                    disabled={onlineOrder_optKey === 'O'}
                    keyValue={this.state.keyValue}
                    onClickFilter={this.getOnlineReg}
                    setStartDate={this.setStartDate}
                    setEndDate={this.setEndDate}
                    component='Report'
                />
                </div>

                <div id="onlineOrdFltItem" className={`${styles.filterItem} onlDrpdownDiv`}>
                <DropdownButton id="bg-nested-dropdown" className={`${styles.filterItembtn} reportsDropdown btnText`} title={i18next.t(onlinecreatby_opt)}>
                    <MenuItem id="onlOrdAll" onClick={() => this.onlinecreatby_opt("createdByAll", "2")}>{i18next.t("createdByAll")}</MenuItem>
                    <MenuItem id="onlOrdMe" onClick={() => this.onlinecreatby_opt("me", "0")}>{i18next.t("me")}</MenuItem>
                    <MenuItem id="onlOrdOthers" onClick={() => this.onlinecreatby_opt("others", "1")}>{i18next.t("others")}</MenuItem>
                </DropdownButton>
                </div>
            </div>
            <div className={styles.exportOptions}>
                <div className={`${styles.exportfileBaracc} allExportFilter`}>
                <div className="commonGoBtn" id="onlGobtn">
                    <button type="button" id="onlOrdRefreshBtn" className={this.state.isRefreshDisabled === true ? `${styles.disabled} ${styles.goBtn}` : `${styles.goBtn}` } onClick={this.getOnlineReg}>
                      {this.props.refreshIcon}
                    </button>
                </div>
                <label className={this.state.loadtableflag === true ? "disableLabel" : null}>
                    {(this.props.OnlinetbleData.length !== 0) &&
                    <span>
                        <ExcelFile  filename={fileName} element={(<img src="/images/xls.png" />)}>
                        {order_opt === 'O' ? <ExcelSheet dataSet={multiDataSetOut} name="OnlineOrderReport" />
                        : order_opt === 'F' ? <ExcelSheet dataSet={multiDataSetFill} name="OnlineOrderReport" />
                        : order_opt === 'C' ? <ExcelSheet dataSet={multiDataSetCan} name="OnlineOrderReport" />
                        : order_opt === 'E' ? <ExcelSheet dataSet={multiDataSetExp} name="OnlineOrderReport" />
                        : order_opt === 'A' ? <ExcelSheet dataSet={multiDataSetAll} name="OnlineOrderReport" />
                        : null}
                        </ExcelFile>
                    </span>
                    }
                    {(this.props.OnlinetbleData.length === 0) && <img src="/images/xls.png" onClick={this.changeFlag} />}
                    <span><img src="/images/pdf.png" onClick={()=>{this.generatePdf("PDF")}} id="onlOrdPDF" /></span>
                </label>
                </div>
            </div>
          </div>
        </div>

        <div id="onlineOrdTable" className={`${styles.onlineOrdTable} onlineOrdTable reportTblBg`}>
          {this.state.loadtableflag === true ?
            <div className={styles.rptoverlay} >
              <i className="fa fa-spinner fa-spin spin-big"></i>
            </div>
          : null}

          {order_opt === 'O' ?
            <div className={`${styles.OnlineOrderOutstandingTable} reportsTblGrid`} >
              <Grid rows={this.props.OnlinetbleData} columns={Outstandingcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={OutOrdersCell} />
                <TableHeaderRow showSortingControls id="ordertbl" />
                <TableColumnVisibility columnExtensions={this.state.outLmtOrdColumnExtensions} hiddenColumnNames={this.state.HiddenOutstandingTableCol} onHiddenColumnNamesChange={this.onChangeHiddenOutstandingTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
            // </Card>
          : null}

          {order_opt === 'F' ?
            <div className={`${styles.OnlineOrderFillTable} reportsTblGrid`} >
              <Grid rows={this.props.OnlinetbleData} columns={Filledcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                :this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} cellComponent={FillOrdersCell} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.HiddenFillTableCol} onHiddenColumnNamesChange={this.onChangeHiddenFillTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
          : null}


          {order_opt === 'C' ?
            <div className={`${styles.OnlineOrderCancelledTable} reportsTblGrid`} >
              <Grid rows={this.props.OnlinetbleData} columns={Cancelledcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.HiddenCancelledTableCol} onHiddenColumnNamesChange={this.onChangeHiddenCancelledTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
          : null}


          {order_opt === 'E' ?
            <div className={`${styles.OnlineOrderFillTable} reportsTblGrid`} >
              <Grid rows={this.props.OnlinetbleData} columns={Expiredcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.HiddenExpiredTableCol} onHiddenColumnNamesChange={this.onChangeHiddenExpiredTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser  containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
          : null}


          {order_opt === 'A'  ?
            <div className={`${styles.OnlineOrderAllTable} reportsTblGrid`} >
              <Grid rows={this.props.OnlinetbleData} columns={Allcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} cellComponent={AllOrdersCell} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.HiddenAllTableCol} onHiddenColumnNamesChange={this.onChangeHiddenAllTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser  containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
          : null}
        </div>
      </div>
    );
  }
}
